import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../lib/api";

export default function Legal() {
  const { page } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { setData(null); api.get(`/content/${page}`).then((r) => setData(r.data.data || {})).catch(() => setData({})); }, [page]);
  if (!data) return <div className="luxy-container py-32 text-center font-serif text-xl tracking-[0.3em] text-stonemuted animate-pulse">LUXYREIGN</div>;

  return (
    <div className="luxy-container py-16 sm:py-24 max-w-3xl">
      <p className="eyebrow mb-3">Legal & Policies</p>
      <h1 className="font-serif text-4xl sm:text-5xl text-pitch tracking-tight mb-8">{data.title || "Policy"}</h1>
      {data.sections ? data.sections.map((s, i) => (
        <div key={i} className="mb-10">
          <h2 className="font-serif text-2xl text-pitch mb-3">{s.heading}</h2>
          <p className="text-charcoal/80 leading-relaxed">{s.body}</p>
        </div>
      )) : (
        <p className="text-charcoal/80 leading-relaxed whitespace-pre-line">{data.body || "This policy has not yet been supplied."}</p>
      )}
      <div className="mt-14 border-t border-linen pt-8">
        <p className="text-xs text-stonemuted font-mono uppercase tracking-widest">This document contains placeholder wording and REQUIRES LEGAL REVIEW BEFORE LAUNCH.</p>
      </div>
    </div>
  );
}
